module.exports = __webpack_public_path__ + "img/fi-rr-paper-plane.83505fb0.svg";